import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, SignIn } from "@phosphor-icons/react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
    const nav = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await axios.post(
                `${API}/admin/login`,
                { username, password },
                { timeout: 15000 }
            );
            localStorage.setItem("admin_token", data.token);
            localStorage.setItem("admin_username", data.username);
            toast.success(`Welcome, ${data.username}`);
            nav("/admin/entries", { replace: true });
        } catch (err) {
            const msg =
                err.response?.data?.detail ||
                err.message ||
                "Could not sign in.";
            setError(typeof msg === "string" ? msg : "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center px-4">
            <form
                onSubmit={submit}
                className="w-full max-w-md border-2 border-zinc-900 bg-white p-6 sm:p-8 shadow-brutal"
            >
                <div className="flex items-center gap-2 mb-6">
                    <div className="w-10 h-10 bg-zinc-900 flex items-center justify-center">
                        <Lock size={20} weight="bold" color="#FFCC00" />
                    </div>
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-zinc-500">
                            Admin
                        </div>
                        <div className="font-display text-xl font-extrabold tracking-tight">
                            Sign in to dashboard
                        </div>
                    </div>
                </div>

                <label className="block text-[11px] uppercase tracking-[0.18em] font-bold text-zinc-500 mb-2">
                    Username / Email
                </label>
                <input
                    data-testid="admin-username"
                    type="text"
                    autoComplete="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="admin@example.com"
                    className="w-full bg-white border-2 border-zinc-900 px-4 py-3 text-base font-mono-tab text-zinc-900 focus:outline-none focus:shadow-brutal-sm rounded-none"
                    required
                />

                <label className="block text-[11px] uppercase tracking-[0.18em] font-bold text-zinc-500 mt-4 mb-2">
                    Password
                </label>
                <input
                    data-testid="admin-password"
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-white border-2 border-zinc-900 px-4 py-3 text-base font-mono-tab text-zinc-900 focus:outline-none focus:shadow-brutal-sm rounded-none"
                    required
                />

                {error && (
                    <div
                        data-testid="admin-login-error"
                        className="mt-4 border-2 border-zinc-900 bg-white px-3 py-2 text-xs font-bold text-zinc-900"
                    >
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-btn"
                    className="mt-6 w-full border-2 border-zinc-900 bg-zinc-900 text-[#FFCC00] py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#FFCC00] hover:text-zinc-900 transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2"
                >
                    {loading ? (
                        <>
                            <span className="inline-block w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            Signing in…
                        </>
                    ) : (
                        <>
                            <SignIn size={14} weight="bold" />
                            Sign in
                        </>
                    )}
                </button>
            </form>
        </div>
    );
}
